import { render, staticRenderFns } from "./MinorApplication.vue?vue&type=template&id=98b15852"
import script from "./MinorApplication.vue?vue&type=script&lang=js"
export * from "./MinorApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports